import { EntityRepository, Repository } from "typeorm";
import { ForkLiftJobs } from "../fork-lift-jobs.entity";

@EntityRepository(ForkLiftJobs)
export class ForkLiftJobsRepository extends Repository<ForkLiftJobs>{
}